import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { generateUniqueFileName } from "@/shared/utils/helpers";
export const ProjectDetailsDialog = (props) => {
    const [filename, setFilename] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        if (props.visible) {
            if (props.type === "upload") {
                const blobType = props.blob?.type || "application/octet-stream";
                setFilename(generateUniqueFileName(blobType));
            }
            else {
                setFilename(props.currentFileName);
            }
        }
    }, [props.visible]);
    const handleSave = async () => {
        try {
            setIsLoading(true);
            if (props.type === "upload") {
                await props.onConfirm(filename);
            }
            else {
                await props.onConfirm(props.currentFileName, filename);
            }
            props.onHide();
        }
        catch (error) {
            console.error("Error during operation:", error);
        }
        finally {
            setIsLoading(false);
        }
    };
    const footerContent = (_jsxs("div", { className: "flex items-center justify-end gap-x-5", children: [_jsx(Button, { label: "Cancel", icon: "pi pi-times", onClick: props.onHide, className: "py-2 px-4 text-[#344054] rounded-[8px] shadow-sm border border-[#EAECF0]", outlined: true, disabled: isLoading }), _jsx(Button, { label: "Save", icon: "pi pi-check", onClick: handleSave, iconPos: "right", className: "py-2 px-4 transition-all duration-300 bg-gradient-to-r from-[#2546F0] to-[#5928ED] hover:from-[#0039cc] hover:to-[#0039cc] text-white rounded-[8px] shadow-sm hover:bg-indigo-700", loading: isLoading })] }));
    return (_jsx(Dialog, { header: _jsx("h3", { className: "text-[#344054] text-lg font-semibold flex items-center gap-x-3", children: props.type === "upload" ? "Upload File Details" : "Edit File Name" }), visible: props.visible, style: { width: "50vw" }, onHide: props.onHide, appendTo: props.parentRef?.current, footer: footerContent, draggable: false, resizable: false, closable: !isLoading, className: "max-w-[600px] font-content rounded-[8px] bg-[#fff] shadow-none border", maskClassName: "!absolute backdrop-blur-sm border border-[#d1d5db]", children: _jsx("div", { className: "flex flex-col space-y-4", children: _jsxs("div", { children: [_jsx("div", { className: "w-full flex justify-between items-center", children: _jsxs("label", { htmlFor: "filename", className: "block text-base font-medium text-gray-700", children: ["File Name ", _jsx("span", { className: "text-[red]", children: "*" })] }) }), _jsx("input", { type: "text", id: "filename", value: filename, onChange: (e) => setFilename(e.target.value), disabled: isLoading, className: "w-full mt-1 p-2 border rounded-[8px] border-[#D1D5DB] text-sm" })] }) }) }));
};
